const S3_IMAGE_FRAGMENT = `
...on s3_Asset {
  url
  width
  height
  imageAltText
  animatedGif
}
`

export default S3_IMAGE_FRAGMENT
